import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { Button } from "@mantine/core";
import { ADD_COMMIT, AppContext, TOGGLE_TERMS } from "../../../context";
import { commitPurchase, getResponsible } from "../util";
import { getMethodById, SWISH } from "../../Payments/constants";
import moment from "moment";

const Footer = (props) => {
  const {
    invalid,
    noItems,
    sale,
    paymentMethods,
    providesResponsible,
    setIsOnePageCheckoutActive,
    responsibleData,
    deliveryMethod,
    deliveryMethods,
  } = props;
  const { state, dispatch } = useContext(AppContext);
  const rdxDispatch = useDispatch();
  const {
    config,
    culture,
    language,
    paymentMethodId,
    saleId,
    identifier,
    currency,
    hasOptedIn,
  } = state;
  const validPaymentMethods =
    paymentMethods &&
    Object.keys(paymentMethods).filter((key) => paymentMethods[key].isActive);

  const responsible = !providesResponsible
    ? null
    : getResponsible(responsibleData);
  const commitData = {
    paymentMethodId,
    identifier,
    culture,
    currency,
    responsible,
    optIn: hasOptedIn,
  };

  const submit = () => {
    const selectedMethod = getMethodById(paymentMethodId);
    if (
      !config?.useExternalTermsForOnePagePayments ||
      !selectedMethod.supportsOnePage ||
      selectedMethod.name === "swish"
    ) {
      dispatch({ type: TOGGLE_TERMS });
      return;
    }
    commitPurchase(
      config.apiUri,
      saleId,
      selectedMethod.supportsOnePage,
      setIsOnePageCheckoutActive,
      rdxDispatch,
      commitData
    );
  };

  const submitSwish = () => {
    dispatch({ type: ADD_COMMIT, payload: commitData });
    dispatch({ type: TOGGLE_TERMS });
  };

  const disabled = () => {
    if (deliveryMethods && deliveryMethods.length > 0 && !deliveryMethod) {
      return true;
    }
    const articlesExpired = moment().isAfter(sale.firstArticleExpiresAt);
    if (noItems || articlesExpired) {
      return true;
    }

    if (
      sale.amount > 0 &&
      (validPaymentMethods.length === 0 || paymentMethodId.length === 0)
    ) {
      return true;
    }

    if (providesResponsible === false || !invalid) {
      return false;
    }

    return true;
  };

  return (
    <div
      style={{
        marginTop: "24px",
      }}
    >
      <div>
        <Button
          color="primary"
          disabled={disabled()}
          onClick={() => {
            if (paymentMethodId === SWISH) {
              submitSwish();
            } else {
              submit();
            }
          }}
          className={"primaryButton"}
          id="toPaymentButton"
          fullWidth
          size="md"
        >
          {state.giftCertificate?.coverTotalCost
            ? language.Make_Order
            : language.Go_To_Payment}
          {/*{language?.Go_To_Payment || "to payment"}*/}
        </Button>
      </div>
    </div>
  );
};

export default Footer;
